import pagination from '../../utils/pagination'
import {
  PAYMENTS_BATCH_DELETE_REQUEST, PAYMENTS_BATCH_DELETE_SUCCESS, PAYMENTS_BATCH_DELETE_FAILURE,
  PAYMENTS_FETCH_MANY_REQUEST, PAYMENTS_FETCH_MANY_SUCCESS, PAYMENTS_FETCH_MANY_FAILURE,
  PAYMENTS_FETCH_REQUEST, PAYMENTS_FETCH_SUCCESS, PAYMENTS_FETCH_FAILURE,
  PAYMENTS_SAVE_REQUEST, PAYMENTS_SAVE_SUCCESS, PAYMENTS_SAVE_FAILURE,
  EMPTY_PAYMENTS,
  CLEAR_ERRORS
} from './types'

export default {
  [PAYMENTS_BATCH_DELETE_REQUEST] (state) {
    state.deleting = true
  },
  [PAYMENTS_BATCH_DELETE_SUCCESS] (state) {
    state.deleting = false
  },
  [PAYMENTS_BATCH_DELETE_FAILURE] (state) {
    state.deleting = false
  },
  [PAYMENTS_FETCH_MANY_REQUEST] (state) {
    state.data = []
    state.loading = true
  },
  [PAYMENTS_FETCH_MANY_SUCCESS] (state, { data }) {
    state.data = data.data
    state.page = pagination(data)
    state.loading = false
  },
  [PAYMENTS_FETCH_MANY_FAILURE] (state, { validationErrors }) {
    state.validationErrors = validationErrors || {}
    state.loading = false
  },
  [PAYMENTS_FETCH_REQUEST] (state) {
    state.single = {}
    state.loading = true
  },
  [PAYMENTS_FETCH_SUCCESS] (state, { data }) {
    state.single = data
    state.loading = false
  },
  [PAYMENTS_FETCH_FAILURE] (state) {
    state.loading = false
  },
  [PAYMENTS_SAVE_REQUEST] (state) {
    state.data = []
    state.saving = true
  },
  [PAYMENTS_SAVE_SUCCESS] (state) {
    state.saving = false
  },
  [PAYMENTS_SAVE_FAILURE] (state, { validationErrors }) {
    state.validationErrors = validationErrors || {}
    state.saving = false
  },
  [EMPTY_PAYMENTS] (state) {
    state.data = []
    state.loading = false
    state.saving = false
  },
  [CLEAR_ERRORS] (state) {
    state.validationErrors = []
    state.loading = false
    state.saving = false
  }
}
